import React from 'react';
import AccordionSummaryOrder from '../AccordionSummaryOrder';
import GroupedPartCard from '../GroupedPartCard';
import AccordionDetailsOrder from '../AccordionDetailsOrder';

const AccordionOrder = ({
  Button,
  expanded,
  orderDataMap,
  isNeitherCardExpandedYet,
  handleAccordionChange,
  changeOrderGroupStatus,
}) => {
  return (
    <div>
      <div>
        <AccordionSummaryOrder
          expanded={expanded}
          orderDataMap={orderDataMap}
          handleAccordionChange={handleAccordionChange}
        />
        {expanded ? (
          <AccordionDetailsOrder
            expanded={expanded}
            orderId={orderDataMap.order.id}
            handleAccordionChange={handleAccordionChange}
            isNeitherCardExpandedYet={isNeitherCardExpandedYet}
            changeOrderGroupStatus={changeOrderGroupStatus}
          />
        ) : (
          <GroupedPartCard
            Button={Button}
            expanded={expanded}
            orderedProductsList={orderDataMap.filteredProducts}
            tip={orderDataMap.order.payment?.tipAmount}
            isNeitherCardExpandedYet={isNeitherCardExpandedYet}
          />
        )}
      </div>
    </div>
  );
};

export default AccordionOrder;
